import { createContext, useContext } from 'react';

interface ImageProxyContextType {
    processUrl: (url: string) => Promise<string>;
}

const defaultContext: ImageProxyContextType = {
    processUrl: async (url: string) => url,
};

export const ImageProxyContext = createContext<ImageProxyContextType>(defaultContext);

export const useImageProxy = () => useContext(ImageProxyContext);
